import './Item.css';
import { useState } from 'react';
import { COLOR_CUERPO_CLARO } from '../../Config.js';

const Item = (props) => {
    const [isComplete, setIsComplete] = useState(false);
    const [entre, setEntre] = useState(false);

    const shortDescription = (description) => {
        if(description.length > 25) {
            return description.slice(0,25).concat("...");
        } else {
            return description;
        }
    }

    const formatterPeso = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0
      })

    const redirigir = () => {
        if(!props.link == "") {
            window.location.href = props.link;
        }
    }

    return <ul className={COLOR_CUERPO_CLARO ? 'item' : 'item oscuro'} key={props.index}>
                {props.image != ""
                ? <div onClick={redirigir} className='itemText'>
                    <li className={COLOR_CUERPO_CLARO ? 'name' : 'name oscuro'}>{props.name}</li>
                    {isComplete
                    ? <li className={COLOR_CUERPO_CLARO ? 'description' : 'description oscuro'}>{props.description}</li>
                    : <li className={COLOR_CUERPO_CLARO ? 'description' : 'description oscuro'}>{shortDescription(props.description)}</li>
                    }
                    {props.description != shortDescription(props.description)
                    ? <div className={COLOR_CUERPO_CLARO ? 'btnComplete' : 'btnComplete oscuro'}>
                        {isComplete
                        ? <li className="verMas" onClick={() => {setIsComplete(false); setEntre(true)}}>Ver menos...</li>
                        : entre
                        ? <li className="verMenos" onClick={() => setIsComplete(true)}>Ver más...</li>
                        : <li onClick={() => setIsComplete(true)}>Ver más...</li>
                        }
                        </div>
                    : null
                    }
                    <li className={COLOR_CUERPO_CLARO ? 'precio' : 'precio oscuro'}>{formatterPeso.format(props.price)}</li>
                </div>
                : <div onClick={redirigir} className='itemTextLarge'>
                    <li className={COLOR_CUERPO_CLARO ? 'name' : 'name oscuro'}>{props.name}</li>
                    {isComplete
                    ? <li className={COLOR_CUERPO_CLARO ? 'description' : 'description oscuro'}>{props.description}</li>
                    : <li className={COLOR_CUERPO_CLARO ? 'description' : 'description oscuro'}>{shortDescription(props.description)}</li>
                    }
                    {props.description != shortDescription(props.description)
                    ? <div className={COLOR_CUERPO_CLARO ? 'btnComplete' : 'btnComplete oscuro'}>
                        {isComplete
                        ? <li className="verMas" onClick={() => {setIsComplete(false); setEntre(true)}}>Ver menos...</li>
                        : entre
                        ? <li className="verMenos" onClick={() => setIsComplete(true)}>Ver más...</li>
                        : <li onClick={() => setIsComplete(true)}>Ver más...</li>
                        }
                        </div>
                    : null
                    }
                    <li className={COLOR_CUERPO_CLARO ? 'precio' : 'precio oscuro'}>{formatterPeso.format(props.price)}</li>
                </div>
                }
                <div className='itemImg'>
                    {props.image != ""
                    ? <img src={props.image} alt={props.name} />
                    : ""
                    }
                </div>
            </ul>
}

export default Item;